// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__w-Fb9","centeredImage":"styles_centeredImage__utl9E","centerImage":"styles_centerImage__b0qHi","text":"styles_text__1i9pq"};